"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Context_1 = require("./Context");
;
function I18ZenProvider(_a) {
    var locales = _a.locales, remoteLocales = _a.remoteLocales, initialLocale = _a.initialLocale, fallbackLocale = _a.fallbackLocale, errorCallback = _a.errorCallback, children = _a.children;
    var _b = React.useState(locales || {}), database = _b[0], setDatabase = _b[1];
    var _c = React.useState(initialLocale || fallbackLocale || null), currentLocale = _c[0], setCurrentLocale = _c[1];
    function fetchLocale(locale, url) {
        fetch(url).then(function (response) { return response.json().then(function (data) {
            var _a;
            setDatabase(__assign(__assign({}, database), (_a = {}, _a[locale] = __assign({}, data), _a)));
        }).catch(errorCallback); });
    }
    function changeLocale(locale) {
        if (!database[locale]) {
            errorCallback && errorCallback(new Error('Locale not found'));
            return;
        }
        setCurrentLocale(locale);
    }
    function getCurrentLocale() {
        return currentLocale;
    }
    function __(key, params) {
        if (!currentLocale && !fallbackLocale) {
            return key;
        }
        var localeObj = null;
        if (currentLocale) {
            localeObj = database[currentLocale];
        }
        else if (fallbackLocale) {
            localeObj = database[fallbackLocale];
        }
        if (!localeObj) {
            return key;
        }
        var sentence = localeObj[key];
        if (!sentence) {
            return key;
        }
        if (params) {
            var pKeys = Object.keys(params);
            for (var i = 0; i < pKeys.length; i++) {
                var pKey = pKeys[i];
                var param = params[pKey];
                sentence = sentence.replace('{{' + pKey + '}}', param);
            }
        }
        return sentence;
    }
    React.useEffect(function () {
        if (remoteLocales) {
            for (var i = 0; i < remoteLocales.length; i++) {
                var remoteLocale = remoteLocales[i];
                fetchLocale(remoteLocale.locale, remoteLocale.url);
            }
        }
    }, []);
    return (React.createElement(Context_1.default.Provider, { value: { changeLocale: changeLocale, __: __, getCurrentLocale: getCurrentLocale } }, children));
}
exports.I18ZenProvider = I18ZenProvider;
function useI18Zen() {
    var _a = React.useContext(Context_1.default), __ = _a.__, changeLocale = _a.changeLocale, getCurrentLocale = _a.getCurrentLocale;
    return {
        __: __,
        changeLocale: changeLocale,
        getCurrentLocale: getCurrentLocale
    };
}
exports.useI18Zen = useI18Zen;
